import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ORDER_STATUS_TYPE_ENUM } from 'modules/sales/settings/order-status/constants';

import { useMemo } from 'react';

interface IStatusTag {
  value: ORDER_STATUS_TYPE_ENUM;
}

const StatusTag = ({ value }: IStatusTag) => {
  const { t } = useTranslation('orderStatus');

  const _type = useMemo(() => {
    if (ORDER_STATUS_TYPE_ENUM[value] === undefined) {
      return 'none';
    }
    return ORDER_STATUS_TYPE_ENUM[value];
  }, [value]);

  return <Chip size='small' label={t(`fields.orderStatusType.${_type}`)} variant='outlined' />;
};

export default StatusTag;
